// extracted by mini-css-extract-plugin
module.exports = {"container":"__7teS309V","title":"__4CnT5I4_","content":"dQ_AWBSA","singleSearchWordCard":"RKl_sVC8","imageWrapper":"Y5TsU_5i","searchWordImage":"jMgk4cgC","searchWord":"NzzBwaFk"};